import axios from "axios";
import { getBackendUrl } from "@/general";


export const dataGridContratosArrendamientos = async (context, page, search) => {
  const parameters = {
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch('statusLogin', context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/movimientos/api/dataGridContratosArrendamientos`,
      {
        params: parameters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );
    
    return res.data;
  } catch (err) {
    throw err.response;
  }
}

export const crudContratoArrendamiento = async (context, typeAction, id, dataRequest) => {
  const endPoint = "/movimientos/api/contratoArrendamiento/";
  let res;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        // Borra las llaves que no tengan datos
        // OJO tener en cuanta y validar el alcance de funcionalidad

        Object.keys(dataRequest).forEach(key => {
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        console.log(dataRequest);

        res = await axios.post(
          urlService,
          dataRequest,
          {
            headers: paramsHeader
          }
        );

        break;
      case "read":
        res = await axios.get(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );

        break;
      case "update":
        // Borra las llaves que no tengan datos
        // OJO tener en cuanta y validar el alcance de funcionalidad

        Object.keys(dataRequest).forEach(key => {
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        console.log(dataRequest);

        res = await axios.put(
          `${urlService}/${id}`,
          dataRequest,
          {
              headers: paramsHeader
          }
        );

        break;
      case "delete":
        res = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );

        break;
    }

    return res.data;
  } catch (err) {
    throw err.response;
  }
}

// export const guardarContratoArrendamiento = async (context, body) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.post(
//       `${source}/movimientos/api/contratoArrendamiento`,
//       body,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

// export const actualizarContratoArrendamiento = async (context, idRentContract, body) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.put(
//       `${source}/movimientos/api/contratoArrendamiento/${idRentContract}`,
//       body,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

// export const borrarContratoArrendamiento = async (context, idRentContract) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.delete(
//       `${source}/movimientos/api/contratoArrendamiento/${idRentContract}`,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

// export const obtenerContratoArrendamiento = async (context, contractId) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.get(
//       `${source}/movimientos/api/contratoArrendamiento/${contractId}`,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     console.log(err)
//     throw err.response
//   }
// }

export const dataGridProductosArrendamientos = async (context, page, search, contractId) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/contratoArrendamiento/${contractId}/dataGridProductosArrendamientos/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const crudProductoArrendamiento = async (context, typeAction, id, dataRequest) => {
  const endPoint = "/movimientos/api/productoArrendamiento/";
  let res;

  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        // Borra las llaves que no tengan datos
        // OJO tener en cuanta y validar el alcance de funcionalidad

        Object.keys(dataRequest).forEach(key => {
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        console.log(dataRequest);

        res = await axios.post(
          urlService,
          dataRequest,
          {
            headers: paramsHeader
          }
        );

        break;
      case "read":
        res = await axios.get(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );

        break;
      case "update":
        // Borra las llaves que no tengan datos
        // OJO tener en cuanta y validar el alcance de funcionalidad

        Object.keys(dataRequest).forEach(key => {
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        console.log(dataRequest);

        res = await axios.put(
          `${urlService}/${id}`,
          dataRequest,
          {
            headers: paramsHeader
          }
        );

        break;
      case "delete":
        res = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );

        break;
    }

    return res.data;
  } catch (err) {
    throw err.response;
  }
}

// export const guardarProductoArrendamiento = async (context, body) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)

//     const { source } = await getBackendUrl()
//     const res = await axios.post(
//       `${source}/movimientos/api/productoArrendamiento`,
//       body,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     throw err.response
//   }
// }

// export const obtenerProductoArrendamiento = async (context, id) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)
//     const { source } = await getBackendUrl()
//     const res = await axios.get(
//       `${source}/movimientos/api/productoArrendamiento/${id}`,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     throw err.response;
//   }
// }

// export const actualizarProductoArrendamiento = async (context, id, body) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router)

//     const { source } = await getBackendUrl()
//     const res = await axios.put(
//       `${source}/movimientos/api/productoArrendamiento/${id}`,
//       body,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     throw err.response
//   }
// }

// export const borrarProductoArrendamiento = async (context, id) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router);

//     const { source } = await getBackendUrl()
//     const res = await axios.delete(
//       `${source}/movimientos/api/productoArrendamiento/${id}/`,
//       {
//         headers: {
//           'Authorization': `Bearer ${context.$store.state.user.token}`
//         }
//       }
//     )
//     return res.data
//   } catch (err) {
//     throw err.response
//   }
// }
